exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".snclient-campaign-brief-embedded {\n  overflow-y: scroll;\n  width: 100%;\n  background: #fff;\n  position: relative; }\n  .snclient-campaign-brief-embedded > div {\n    width: 100%;\n    height: 100%; }\n\n.snclient_zoid_component__campaign-brief-wrapper {\n  height: 100%; }\n  .snclient_zoid_component__campaign-brief-wrapper > div {\n    width: 100%;\n    height: 100%; }\n\n.snclient_zoid_component__campaign-brief {\n  width: 100%;\n  height: 100%; }\n  .snclient_zoid_component__campaign-brief .zoid-outlet {\n    width: 100%;\n    height: 100%;\n    position: relative; }\n  .snclient_zoid_component__campaign-brief iframe {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--4-2!/root/social-native/socialnative-web/node_modules/sass-loader/lib/loader.js!./components/creator_campaign_brief/index.scss
// module id = 3382
// module chunks = 69